import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFullscreen1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fullscreen-1"><path d="M8 4.75H2.75V9.75M16 4.75H21.25V9.75M21.25 14V19.25H16M8 19.25H2.75V14" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFullscreen1;
